import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { Button } from '../../../components/Button/Button'

export interface PushToDraftAfterEditModallProps {
  show: boolean
  onConfirm: () => void
  onHide: () => void
  isLoading?: boolean
}

export const PushToDraftAfterEditModal: React.FC<PushToDraftAfterEditModallProps> = ({ show, onConfirm, onHide, isLoading }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={
        <div className='d-flex flex-column zocks-gap-3'>
          <h4 className='text-center'>The email was pushed to draft previously. Do you want to update the draft?</h4>
        </div>
      }
      footer={
        <div className='d-flex flex-grow-1 gap-3 align-items-center'>
          <Button variant='secondary' className='flex-grow-1' onClick={onHide}>
            Do not push
          </Button>
          <Button variant='primary' className='flex-grow-1' onClick={onConfirm} loading={isLoading}>
            Push to Draft
          </Button>
        </div>
      }
      centered={true}
    />
  )
}
